import { useParams } from "react-router";
import { useChallengeMembers } from "../api/challenge-members.api";
import {
  useSuspenseInfiniteQuery,
  useSuspenseQuery,
} from "@tanstack/react-query";
import { Suspense } from "react";
import { ChallengeMemberList } from "../SingleParticipants";
import UserCardLoading from "../components/UserCardLoading";
import AvatarFrame from "@/components/icons/AvatarFrame";
import { useChallengeDetail } from "../api/useChallengeDetail";
import { WinnersLoading } from "./Loading";
import { useGetProfile } from "@/pages/profile/api";
import { useTranslation } from "react-i18next";
import { getImageByPriority } from "@/shared/utils/common";
import InfiniteScrollList, {
  checkFetchMore,
} from "@/components/base/InfiniteScrollList";
import { useInfiniteQueryFlatted } from "@/shared/hooks/useInfiniteQueryFlatted";
import ExpandableText from "@/components/common/ExpandableText/ExpandableText.tsx";

const AboutWinners = () => {
  return (
    <Suspense fallback={<WinnersLoading />}>
      <BaseAboutWinners />
    </Suspense>
  );
};

const BaseAboutWinners = () => {
  const { t } = useTranslation();
  const { challengeId } = useParams();

  useGetProfile();
  const { data: challengeDetail } = useSuspenseQuery(
    useChallengeDetail(challengeId)
  );


  // useEffect(() => {
  //   if (challengeDetail.super_winner?.id === profileData?.id) {
  //     showCustomToast(t("congratulations_you_are_winner"), "success", {
  //       icon: <WinnerToastIcon />,
  //       className: "!bg-white/08 backdrop-blur-[10px]",
  //     });
  //     boom();
  //   }
  // }, [challengeDetail.super_winner?.id, profileData]);

  const queryResult = useSuspenseInfiniteQuery(
    useChallengeMembers(challengeId, undefined, true),
  );

  const winnerList = useInfiniteQueryFlatted(queryResult.data);

  return (
    <div className="container">
      {/* 1st-place winner (top of the ranked participant list) */}
      <div className="flex flex-col items-center gap-3 w-full py-[30px]">
        {winnerList.length > 0 && (
          <div className="flex flex-col items-center">
            <div className="rounded-full">
              <AvatarFrame
                avatarSrc={
                  winnerList[0].avatar
                    ? getImageByPriority(winnerList[0].avatar, "large")
                    : ""
                }
                name={winnerList[0].full_name}
              />
            </div>
            <div className="flex flex-col items-center gap-0.5">
              <h2 className="font-semibold leading-4 text-white text-base">
                {winnerList[0].full_name || "Anonymous"}
              </h2>
              <p className="text-sm font-medium text-gray-1">
                {t("super_gift_owner")}
              </p>
            </div>
          </div>
        )}
        <div className="flex flex-col items-center gap-1.5">
          <h2 className="text-[22px] text-white font-bold leading-130">
            {challengeDetail.name}
          </h2>
          <ExpandableText
            className="text-xs leading-140"
            text={challengeDetail.description}
          />
        </div>
      </div>
      {/* Member list */}
      <InfiniteScrollList
        fetchNextPage={queryResult.fetchNextPage}
        canFetchMore={checkFetchMore(queryResult)}
        isFetchingNextPage={queryResult.isFetchingNextPage}
        placeholder={
          <div className="grid gap-3">
            {Array.from({ length: 5 }).map((_, idx) => (
              <UserCardLoading key={idx} />
            ))}
          </div>
        }
      >
        <div className="flex flex-col gap-3">
          <ChallengeMemberList
            members={winnerList}
            isCompleted={true}
            searchMode={false}
            showSeperator={false}
          />
        </div>
      </InfiniteScrollList>
    </div>
  );
};

export default AboutWinners;
